import { API_URL } from "../../config/connect";

function authHeaders() {
  const token = localStorage.getItem("google_id_token");
  if (!token) throw new Error("Not signed in");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

async function request(path, { method = "GET", body, query } = {}) {
  let url = `${API_URL}${path}`;
  if (query && Object.keys(query).length) {
    const qs = new URLSearchParams();
    Object.entries(query).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") qs.append(k, v);
    });
    const qsString = qs.toString();
    if (qsString) url += `?${qsString}`;
  }
  const res = await fetch(url, {
    method,
    headers: authHeaders(),
    body: body ? JSON.stringify(body) : undefined,
  });
  const ct = res.headers.get("content-type") || "";
  const data = ct.includes("application/json") ? await res.json().catch(() => ({})) : await res.text();
  if (!res.ok) {
    const detail = (data && data.error && data.error.message) || (data && data.detail) || res.statusText;
    const err = new Error(typeof detail === "string" ? detail : `HTTP ${res.status}`);
    err.status = res.status;
    err.payload = data;
    throw err;
  }
  return data;
}

// ─── Withdrawals ──────────────────────────────────────────────────────────
export const listWithdrawals = ({ status, page = 1, limit = 20 } = {}) =>
  request("/api/v1/withdrawals/", { query: { status, page, limit } });

export const getWithdrawal = (id) => request(`/api/v1/withdrawals/${id}`);

export const approveWithdrawal = (id) =>
  request(`/api/v1/withdrawals/${id}/approve`, { method: "POST" });

export const rejectWithdrawal = (id, reason) =>
  request(`/api/v1/withdrawals/${id}/reject`, {
    method: "POST",
    query: { reason },
  });

// ─── KYC verification ─────────────────────────────────────────────────────
export const listPendingKyc = ({ status, page = 1, limit = 20 } = {}) =>
  request("/api/v1/profile/verification/admin/pending", {
    query: { status, page, limit },
  });

export const approveKyc = (id) =>
  request(`/api/v1/profile/verification/admin/${id}/approve`, { method: "POST" });

export const rejectKyc = (id, reason) =>
  request(`/api/v1/profile/verification/admin/${id}/reject`, {
    method: "POST",
    query: { reason },
  });

// ─── Dealer finance dashboard ─────────────────────────────────────────────
export const getDealerFinanceDashboard = () =>
  request("/api/v1/dealer-finance/dashboard");

export const getDealerBalances = () => request("/api/v1/dealer-finance/balances");

export const getCommissions = ({ page = 1, limit = 20, ...rest } = {}) =>
  request("/api/v1/dealer-finance/commissions", {
    query: { page, limit, ...rest },
  });

export const getAllTransactions = ({ page = 1, limit = 20, ...rest } = {}) =>
  request("/api/v1/dealer-finance/transactions", {
    query: { page, limit, ...rest },
  });
